'use strict';

/**
 * creatAccountAndLoginEvent event
 *@param {string} event - event name
 *@param {boolean} emailSignup - is email sign up enabled
 *@param {boolean} fromSignUpModal - login from sign up modal
 */
function creatAccountAndLoginEvent(event, emailSignup, fromSignUpModal, email) {
    var pwdlesscheck = $('#pwdlessanalytics').data('pwdlessflag');
    var pageLocation = $('.page').data('action') === 'Order-TrackOrder' ? 'track your order' : 'sign in page';
    var signinErrorMsg= $('.alert-danger .error-mismatch').text();
    var dataLayerAnalytics = {
        datalayerEvent: []
    };
    // eslint-disable-next-line
    var event_name = [];
    var createAccountEvent = {};
    // eslint-disable-next-line
    if (event === 'register') {
        var emailsignuplocation = fromSignUpModal ? 'sign up modal' : 'create an account';
        event_name.push('account_creation_success');
        event_name.push('account_signin_success');
        if(fromSignUpModal) {
            createAccountEvent.account_creation_location = 'sign up modal';
            createAccountEvent.account_signin_location = 'sign up modal';
        } else {
            createAccountEvent.account_creation_location = 'create an account';
            createAccountEvent.account_signin_location = 'create an account';
        }
        createAccountEvent.customer_email_address = email;
        if (emailSignup) {
            event_name.push('email_signup_success');
            createAccountEvent.email_signup_location = emailsignuplocation;
        }
        // eslint-disable-next-line
    } else if (event === 'orderConfirmation') {
        event_name.push('account_creation_success');
        event_name.push('account_signin_success');
        createAccountEvent.account_creation_location = 'order confirmation';
        createAccountEvent.account_signin_location = 'order confirmation';
        if (emailSignup) {
            event_name.push('email_signup_success');
            createAccountEvent.email_signup_location = 'order confirmation';
        }
        // eslint-disable-next-line
    } else if (event === 'login' && fromSignUpModal) {
        event_name.push('account_signin_attempt');
        event_name.push('account_signin_success');
        createAccountEvent.customer_email_address = email;
        createAccountEvent.account_signin_location = 'sign in modal';
        createAccountEvent.signin_method = 'email and password';
        // eslint-disable-next-line
    } else if (event === 'login_failure' && fromSignUpModal) {
        event_name.push('account_signin_attempt');
        event_name.push('account_signin_failed');
        event_name.push('site_interaction');
        event_name.push('error_message');
        createAccountEvent.customer_email_address = email;
        createAccountEvent.account_signin_location = 'sign in modal';
        createAccountEvent.signin_method = 'email and password';
        createAccountEvent.site_interaction = 'signin:enter email and password:error';
        createAccountEvent.error_message = signinErrorMsg;
        // eslint-disable-next-line
    } else if (event === 'login_failure' && !fromSignUpModal) {
        event_name.push('account_signin_attempt');
        event_name.push('account_signin_failed');
        event_name.push('site_interaction');
        event_name.push('error_message');
        createAccountEvent.customer_email_address = email;
        createAccountEvent.account_signin_location = 'track your order';
        createAccountEvent.signin_method = 'email and password';
        createAccountEvent.site_interaction = 'signin:enter email and password:error';
        createAccountEvent.error_message = signinErrorMsg;
        // eslint-disable-next-line
    } else if (event === 'login' && !fromSignUpModal) {
        event_name.push('account_signin_attempt,account_signin_success');
        createAccountEvent.customer_email_address = email;
        createAccountEvent.account_signin_location = pageLocation;
        createAccountEvent.signin_method = 'email and password';
        // eslint-disable-next-line
    } else if (event === 'signinOpen') {
        event_name.push('account_signin_modaldisplay');
        createAccountEvent.account_signin_location = 'sign in modal - cart order summary';
        if (pwdlesscheck) {
            createAccountEvent.signin_method = 'email and password,passwordless login';
        } else {
            createAccountEvent.signin_method = 'email and password';
        }
    } else if (event === 'signinOpenCart') {
        event_name.push('account_signin_modaldisplay');
        createAccountEvent.account_signin_location = 'sign in modal - cart';
        if (pwdlesscheck) {
            createAccountEvent.signin_method = 'email and password,passwordless login';
        } else {
            createAccountEvent.signin_method = 'email and password';
        }
    } else if (event === 'accountSignUp') {
        event_name.push('account_signup_display');
        createAccountEvent.account_signin_location = 'sign up modal';
    } else if (event === 'signInTab') {
        event_name.push('account_signin_modaldisplay');
        createAccountEvent.account_signin_location = 'sign in modal';
        if (pwdlesscheck) {
            createAccountEvent.signin_method = 'email and password,passwordless login';
        } else {
            createAccountEvent.signin_method = 'email and password';
        }
    } else if (event === 'signUpTab') {
        event_name.push('account_signup_modaldisplay');
        createAccountEvent.account_signin_location = 'sign up modal';
    }

    var eventName = '';
    // eslint-disable-next-line
    for (var event = 0; event < event_name.length; event ++) {
        if (event !== event_name.length - 1) {
            eventName += event_name[event] + ',';
        } else {
            eventName += event_name[event];
        }
    }
    createAccountEvent.event_name = eventName;
    if (createAccountEvent.event_name.indexOf('account_signin_success') !== -1) {
        var tealiumData = $('.datalayer-view-event').data('tealium-view');
        if (!!tealiumData && tealiumData.length > 0) {
            createAccountEvent.A1_ID = 'A1_ID' in tealiumData[0] ? tealiumData[0].A1_ID : '';
        }
    }
    dataLayerAnalytics.datalayerEvent.push(createAccountEvent);
    $('body').trigger('datalayerEvent:link', dataLayerAnalytics);
}

/**
 * creatPasswordLessAccountAndLoginEvent event
 *
 */
function creatPasswordLessAccountAndLoginEvent(event, emailSignup, fromSignUpModal, email) {
    var signinErrorMsg= $('.alert-danger .error-mismatch').text();
    var email_errormsg = $('.ds-email-paswd-login-form #form-email-error').eq(0).text();
    var signinFrom = fromSignUpModal ? 'sign in modal' : 'track your order';
    var errorMsg = fromSignUpModal ? $('.request-passwordless-modal-body .request-passwordless-login-body .error-messaging').text() : $('.order-track-section .request-passwordless-login-body .error-messaging').text();
    var dataLayerAnalytics = {
        datalayerEvent: []
    };
    // eslint-disable-next-line
    var event_name = [];
    var createAccountEvent = {};
    // eslint-disable-next-line
    if (event === 'login') {
        event_name.push('account_signin_requestcodesuccess');
        event_name.push('site_interaction');
        createAccountEvent.signin_method = 'passwordless login';
        createAccountEvent.account_signin_location = signinFrom;
        createAccountEvent.site_interaction = 'signin:select signin method:passwordless login';
    } else if (event === 'login_failure') {
        event_name.push('error_message');
        event_name.push('site_interaction');
        createAccountEvent.signin_method = 'passwordless login';
        createAccountEvent.account_signin_location = signinFrom;
        createAccountEvent.site_interaction = 'signin:select signin method:passwordless login:error';
        createAccountEvent.error_message = signinErrorMsg;
    } else if (event === 'loginotp_failure') {
        event_name.push('account_signin_attempt');
        event_name.push('account_signin_failed');
        event_name.push('site_interaction');
        createAccountEvent.account_signin_location = signinFrom;
        createAccountEvent.signin_method = 'passwordless login';
        createAccountEvent.site_interaction = 'signin:passwordless login:enter code:error';
        createAccountEvent.error_message = errorMsg;
        createAccountEvent.customer_email_address = email;
    } else if (event === 'loginotp_success') {
        event_name.push('account_signin_attempt');
        event_name.push('account_signin_success');
        createAccountEvent.account_signin_location = signinFrom;
        createAccountEvent.signin_method = 'passwordless login';
        createAccountEvent.customer_email_address = email;
    } else if (event === 'loginotp_resend') {
        event_name.push('site_interaction');
        createAccountEvent.account_signin_location = signinFrom;
        createAccountEvent.signin_method = 'passwordless login';
        createAccountEvent.site_interaction = 'signin:passwordless login:resend code';
    } else if (event === 'passwordLogin') {
        event_name.push('site_interaction');
        createAccountEvent.account_signin_location = signinFrom;
        createAccountEvent.signin_method = 'email and password';
        createAccountEvent.site_interaction = 'signin:select signin method:email and password';
    } else if (event === 'passwordLogin_failure') {
        event_name.push('error_message');
        event_name.push('site_interaction');
        createAccountEvent.signin_method = 'email and password';
        createAccountEvent.account_signin_location = signinFrom;
        createAccountEvent.site_interaction = 'signin:select signin method:passwordless login:error';
        createAccountEvent.error_message = email_errormsg;
    }

    var eventName = '';
    // eslint-disable-next-line
    for (var event = 0; event < event_name.length; event ++) {
        if (event !== event_name.length - 1) {
            eventName += event_name[event] + ',';
        } else {
            eventName += event_name[event];
        }
    }
    createAccountEvent.event_name = eventName;
    if (createAccountEvent.event_name.indexOf('account_signin_success') !== -1) {
        var tealiumData = $('.datalayer-view-event').data('tealium-view');
        if (!!tealiumData && tealiumData.length > 0) {
            createAccountEvent.A1_ID = 'A1_ID' in tealiumData[0] ? tealiumData[0].A1_ID : '';
        }
    }
    dataLayerAnalytics.datalayerEvent.push(createAccountEvent);
    $('body').trigger('datalayerEvent:link', dataLayerAnalytics);
}

/**
 * emailOptInTracking
 * @param {string} emailSignUpLocation - email_signup_location
 * @param {string} email - email
 */
function emailOptInTracking(emailSignUpLocation, email) {
    var dataLayerAnalytics = {
        datalayerEvent: []
    };
    dataLayerAnalytics.datalayerEvent.push({
        event_name: 'email_signup_success',
        email_signup_location: emailSignUpLocation,
        customer_email_address: email
    });
    $('body').trigger('datalayerEvent:link', dataLayerAnalytics);
}

/**
 * forgotPasswordCTA event
 */
function forgetPasswordCTA() {
    var dataLayerAnalytics = {
        datalayerEvent: []
    };
    dataLayerAnalytics.datalayerEvent.push({ event_name: 'account_forgotpw_modaldisplay' });
    $('body').trigger('datalayerEvent:link', dataLayerAnalytics);
}

 /**
 * checkEmailCTA event
 */
function checkEmailCTA() {
    var dataLayerAnalytics = {
        datalayerEvent: []
    };
    dataLayerAnalytics.datalayerEvent.push({ event_name: 'account_forgotpw_checkemail_modaldisplay' });
    $('body').trigger('datalayerEvent:link', dataLayerAnalytics);
}

/**
 * creatAccountLoginErrorMsg event to capture the empty error message for passwordless login
 */
function accountLoginErrorMsg(event, emailSignup, fromSignUpModal, email) {
    var signinFrom = fromSignUpModal ? 'sign in modal' : 'track your order';
    var email_errormsg = $('.ds-email-paswd-login-form #form-email-error');
    var password_errormsg = $('.ds-email-paswd-login-form #form-password-error');
    var emailErrorMsg = email_errormsg.is(":visible") ? email_errormsg.eq(0).text() : '';
    var passwordErrorMsg = password_errormsg.is(":visible") ? password_errormsg.text() : '';
    var dataLayerAnalytics = {
        datalayerEvent: []
    };

    // eslint-disable-next-line
    var event_name = [];
    var createAccountEvent = {};

    if (event === 'passwordlessLogin') {
        event_name.push('site_interaction,error_message');
        createAccountEvent.signin_method = 'passwordless login';
        createAccountEvent.account_signin_location = signinFrom;
        createAccountEvent.site_interaction = 'signin:select signin method:passwordless login:error';
        createAccountEvent.error_message = emailErrorMsg;
    } else if (event === 'emailPasswordLogin') {
        event_name.push('site_interaction,error_message');
        createAccountEvent.signin_method = 'email and password';
        createAccountEvent.account_signin_location = signinFrom;
        createAccountEvent.site_interaction = 'signin:select signin method:email and password:error';
        if(password_errormsg.is(":visible")) {
            createAccountEvent.error_message = emailErrorMsg + ',' + passwordErrorMsg;
        } else {
            createAccountEvent.error_message = emailErrorMsg;
        }
    }

    var eventName = '';
    // eslint-disable-next-line
    for (var event = 0; event < event_name.length; event ++) {
        if (event !== event_name.length - 1) {
            eventName += event_name[event] + ',';
        } else {
            eventName += event_name[event];
        }
    }

    createAccountEvent.event_name = eventName;
    dataLayerAnalytics.datalayerEvent.push(createAccountEvent);
    $('body').trigger('datalayerEvent:link', dataLayerAnalytics);
}

module.exports = {
    creatAccountAndLoginEvent: creatAccountAndLoginEvent,
    creatPasswordLessAccountAndLoginEvent: creatPasswordLessAccountAndLoginEvent,
    emailOptInTracking: emailOptInTracking,
    forgetPasswordCTA: forgetPasswordCTA,
    checkEmailCTA: checkEmailCTA,
    accountLoginErrorMsg: accountLoginErrorMsg
};
